<template>
  <b-modal
    ref="demandReportModal"
    centered
    title="Zgłoszenie Popytu"
    :visible="demandFormVisible"
    @hidden="hide"
    @show="onShow"
  >
    <template #modal-header="{ close }">
      <h5 class="v-step-0">Zgłaszanie popytu</h5>
      <!-- <button class="cursor-pointer v-step-12" v-on:click="startTour()">
                      <span class="oi oi-question-mark" title="Asystent" aria-hidden="true"></span>
                      <span class="sr-only">Asystenet</span>
                    </button> -->

      <b-row class="pr-3 gap-3"
        ><b-button
          v-if="isMobileDevice"
          class="question-button"
          :variant="contextAssistantActive ? 'warning' : 'secondary'"
          @click="toggleAssistant"
        >
          <span
            :variant="'warning'"
            class="oi oi-question-mark"
            title="Asystent"
            aria-hidden="true"
          ></span>
          <span class="sr-only">Asystenet</span>
        </b-button>
        <button @click="hide" class="close">
          <span aria-hidden="true">&times;</span>
        </button></b-row
      >

      <!-- <i class="bi bi-question-circle"></i> -->
    </template>
    <b-form>
      <b-form-group>
        <b-form-row>
          <b-col>
            <b-alert :show="showAlertMessage" variant="danger" class="mb-0">
              <strong>Uwaga.</strong> {{ alertMessage }}
            </b-alert>
          </b-col>
        </b-form-row>
      </b-form-group>
      <fieldset>
        <b-form-group>
          <b-form-row
            @click="
              showContextAssistant(
                'Pod tym polem znajduje się x (długość geograficzna) miejsa zgłoszenia popytu.'
              )
            "
          >
            <b-col md="3" offset-md="1">
              <label class="col-form-label" for="x">X</label>
            </b-col>
            <b-col md="4">
              <b-form-input
                id="x"
                ref="x"
                :disabled="true"
                v-model="demand.x"
                class="form-control"
                type="number"
                step="0.0001"
              />
            </b-col>
          </b-form-row>
        </b-form-group>
        <b-form-group>
          <b-form-row
            @click="
              showContextAssistant(
                'Pod tym polem znajduje się y (szerokość geograficzna) miejsa zgłoszenia popytu.'
              )
            "
          >
            <b-col md="3" offset-md="1">
              <label class="col-form-label" for="y">Y</label>
            </b-col>
            <b-col md="4">
              <b-form-input
                id="y"
                ref="y"
                :disabled="true"
                v-model="demand.y"
                class="form-control"
                type="number"
                step="0.0001"
              />
            </b-col>
          </b-form-row>
        </b-form-group>
        <b-form-group>
          <b-form-row
            @click="
              showContextAssistant(
                'Pod tym polem znajduje się województwo miejsa zgłoszenia popytu.'
              )
            "
          >
            <b-col md="3" offset-md="1">
              <label class="col-form-label" for="voivodeship"
                >Województwo *</label
              >
            </b-col>
            <b-col md="5">
              <b-form-input
                id="voivodeship"
                :disabled="true"
                ref="voivodeship"
                v-model="demand.voivodeship"
                class="form-control"
              />
            </b-col>
          </b-form-row>
        </b-form-group>
        <b-form-group>
          <b-form-row
            @click="
              showContextAssistant(
                'Pod tym polem znajduje się powiat miejsa zgłoszenia popytu.'
              )
            "
          >
            <b-col md="3" offset-md="1">
              <label class="col-form-label" for="county">Powiat *</label>
            </b-col>
            <b-col md="5">
              <b-form-input
                id="county"
                :disabled="true"
                ref="county"
                v-model="demand.county"
                class="form-control"
              />
            </b-col>
          </b-form-row>
        </b-form-group>
        <b-form-group>
          <b-form-row
            @click="
              showContextAssistant(
                'Pod tym polem znajduje się gmina miejsa zgłoszenia popytu.'
              )
            "
          >
            <b-col md="3" offset-md="1">
              <label class="col-form-label" for="commune">Gmina *</label>
            </b-col>
            <b-col md="5">
              <b-form-input
                id="commune"
                ref="commune"
                :disabled="true"
                v-model="demand.commune"
                class="form-control"
              />
            </b-col>
          </b-form-row>
        </b-form-group>
        <b-form-group>
          <b-form-row
            @click="
              showContextAssistant(
                'Pod tym polem znajduje się miejscowość miejsa zgłoszenia popytu.'
              )
            "
          >
            <b-col md="3" offset-md="1">
              <label class="col-form-label" for="city">Miejscowość *</label>
            </b-col>
            <b-col md="5">
              <b-form-input
                id="city"
                ref="city"
                :disabled="isCityExists"
                v-model="demand.city"
                class="form-control"
              />
            </b-col>
          </b-form-row>
        </b-form-group>
        <b-form-group>
          <b-form-row
            @click="
              showContextAssistant(
                'Pod tym polem znajduje się ulica miejsa zgłoszenia popytu.'
              )
            "
          >
            <b-col md="3" offset-md="1">
              <label class="col-form-label" for="street">Ulica *</label>
            </b-col>
            <b-col md="5">
              <b-form-input
                id="street"
                ref="street"
                :disabled="isStreetExists"
                v-model="demand.street"
                class="form-control"
              />
            </b-col>
          </b-form-row>
        </b-form-group>
        <b-form-group>
          <b-form-row
            @click="
              showContextAssistant(
                'Pod tym polem znajduje się numer którego dotyczy popyt.'
              )
            "
          >
            <b-col md="3" offset-md="1">
              <label class="col-form-label" for="number">Numer *</label>
            </b-col>
            <b-col md="5">
              <b-form-input
                id="number"
                ref="number"
                :disabled="isNumberExists"
                v-model="demand.number"
                class="form-control"
              />
            </b-col>
          </b-form-row>
        </b-form-group>
        <b-form-group>
          <b-form-row
            @click="
              showContextAssistant(
                'Pod tym polem należy podać kontaktowy adres E-mail.'
              )
            "
          >
            <b-col md="3" offset-md="1">
              <label class="col-form-label" for="email">E-mail</label>
            </b-col>
            <b-col md="5">
              <b-form-input
                id="email"
                ref="email"
                v-model="demand.email"
                class="form-control"
              />
            </b-col>
          </b-form-row>
        </b-form-group>
        <b-form-group>
          <b-form-row
            @click="
              showContextAssistant(
                'Pod tym polem należy podać kontaktowy numer telefonu.'
              )
            "
          >
            <b-col md="3" offset-md="1">
              <label class="col-form-label" for="phoneNumber"
                >Numer Telefonu</label
              >
            </b-col>
            <b-col md="5">
              <b-form-input
                id="number"
                ref="phoneNumber"
                v-model="demand.phoneNumber"
                class="form-control"
              />
            </b-col>
          </b-form-row>
        </b-form-group>
        <b-form-group>
          <b-form-row
            @click="
              showContextAssistant(
                'Pod tym polem należy wybrać jakiego rodzaju serwisu dotyczy zgłoszenie popytu.'
              )
            "
          >
            <b-col md="3" offset-md="1">
              <label class="col-form-label" for="service">Serwis *</label>
            </b-col>
            <b-col md="5">
              <b-form-select
                id="service"
                ref="service"
                v-model="service"
                :options="serviceTypes.map(type => type.displayName)"
                @change="onChange"
                class="form-control"
              />
            </b-col>
          </b-form-row>
        </b-form-group>
        <b-form-group v-if="showInternetSpeed">
          <b-form-row
            @click="
              showContextAssistant(
                'Pod tym polem należy wybrać wobec jakiej prędkości internetu składany jest formularz popytu.'
              )
            "
          >
            <b-col md="3" offset-md="1">
              <label class="col-form-label" for="internetSpeed"
                >Prędkość internetu</label
              >
            </b-col>
            <b-col md="5">
              <b-form-select
                id="internetSpeed"
                ref="internetSpeed"
                v-model="demand.internetSpeed"
                :options="internetSpeeds"
                class="form-control"
              />
            </b-col>
          </b-form-row>
        </b-form-group>
      </fieldset>
    </b-form>
    <div slot="modal-footer">
      <b-btn variant="primary" @click="publishDemand">Zapisz</b-btn>
      <b-btn variant="outline-secondary" @click="hide">Anuluj</b-btn>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { CoordinateSystems } from '../common/mapEnums';
import {
  WINDOW_DEMAND_FORM_HIDE,
  TOGGLE_CONTEXT_ASSISTANT
} from '../store/mutations.type';
import { DISPLAY_CONTEXT_ASSISTANT_MESSAGE } from '../store/actions.type';
import { defaultCoreCipherList } from 'constants';

export default {
  name: 'DemandFormWindow',
  data: function() {
    return {
      demand: {
        x: undefined,
        y: undefined,
        voivodeship: undefined,
        county: undefined,
        commune: undefined,
        city: undefined,
        street: undefined,
        number: undefined,
        email: undefined,
        phoneNumber: undefined,
        service: undefined,
        internetSpeed: undefined
      },
      service: undefined,
      requiredFieldsEmpty: false,
      serviceTypes: [
        { displayName: 'Internet', value: 'Internet' },
        { displayName: 'Telefon', value: 'Phone' },
        { displayName: 'Telewizja', value: 'TV' },
        { displayName: 'Telewizja i Internet', value: 'TV and Internet' },
        { displayName: 'Hot-spot', value: 'Hot-spot' }
      ],
      internetSpeeds: [
        'Co najmniej 1 Mb/s',
        'Co najmniej 2 Mb/s',
        'Co najmniej 4 Mb/s',
        'Co najmniej 6 Mb/s',
        'Co najmniej 8 Mb/s',
        'Co najmniej 10 Mb/s',
        'Co najmniej 20 Mb/s',
        'Co najmniej 30 Mb/s',
        'Co najmniej 40 Mb/s',
        'Co najmniej 60 Mb/s',
        'Co najmniej 80 Mb/s',
        'Co najmniej 100 Mb/s',
        'Co najmniej 120 Mb/s',
        'Co najmniej 150 Mb/s',
        'Co najmniej 250 Mb/s',
        'Co najmniej 500 Mb/s',
        'Co najmniej 1 Gb/s',
        'Co najmniej 2,5 Gb/s',
        'Co najmniej 10 Gb/s',
        'Co najmniej 40 Gb/s',
        'Co najmniej 100 Gb/s'
      ]
    };
  },
  computed: {
    ...mapGetters([
      'demandFormVisible',
      'demandForm',
      'isMobileDevice',
      'contextAssistantActive'
    ]),
    alertMessage() {
      if (this.requiredFieldsEmpty)
        return 'Nie wszystkie wymagane pola zostały uzupełnione.';
      else return null;
    },
    showAlertMessage() {
      return !!this.alertMessage;
    },
    showInternetSpeed() {
      return ['Internet', 'Telewizja i Internet', 'Hot-spot'].includes(
        this.service
      );
    },
    isCityExists() {
      return this.demandForm.city !== null && this.demandForm.city.length > 0;
    },
    isStreetExists() {
      return (
        this.demandForm.street !== null && this.demandForm.street.length > 0
      );
    },
    isNumberExists() {
      return this.demandForm.number !== null;
    }
  },
  methods: {
    areRequiredFieldsFilled() {
      const requiredFields = [
        'x',
        'y',
        'voivodeship',
        'county',
        'commune',
        'city',
        'street',
        'number',
        'service'
      ];
      return requiredFields.every(
        field =>
          this.demand[field] !== undefined &&
          this.demand[field] !== null &&
          this.demand[field] !== ''
      );
    },
    publishDemand() {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message: 'Przycisk ten uruchamia usługę zgłaszania poputu.'
        });
      } else {
        if (!this.areRequiredFieldsFilled()) {
          this.requiredFieldsEmpty = true;
          return;
        }
        this.hide();
        this.$emit('publish-demand', this.demand);
      }
    },
    onChange(selectedDisplayName) {
      const selectedType = this.serviceTypes.find(
        type => type.displayName === selectedDisplayName
      );
      if (selectedType) {
        this.demand.service = selectedType.value;
      }
    },
    hide() {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message:
            'Przycisk ten Czyści formularz i zamyka narzędzie zgłaszania popytu.'
        });
      } else {
        this.$store.commit(WINDOW_DEMAND_FORM_HIDE);
      }
    },
    onShow() {
      this.demand = { ...this.demandForm };
      this.service = undefined;
      this.requiredFieldsEmpty = false;
    },
    toggleAssistant() {
      this.$store.commit(TOGGLE_CONTEXT_ASSISTANT);
    },
    showContextAssistant(message) {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message: message
        });
      }
    }
  },
  watch: {
    selectedService(newVal) {
      const selectedType = this.serviceTypes.find(
        type => type.displayName === newVal
      );
      if (selectedType) {
        this.demand.service = selectedType.value;
      }
    }
  }
};
</script>
